import SignerRolesView from '../SignerRolesView.vue'
import SignerRoleList  from '../Pages/SignerRoleList.vue'

// CDEF011 §5: Mantenimiento > Roles de firmante (catálogo y cobertura de firmantes).
const routes = [
  {
    path: '/mantenimiento/roles-firmante',
    component: SignerRolesView,
    children: [
      { path: '', name: 'signer-role-list', component: SignerRoleList },
    ],
  },
]

export default routes
